import axios, { AxiosResponse } from "axios";
import { useQuery } from "@tanstack/react-query";
import {
  ShadowTestResultResponse,
  Stage,
} from "../lusca-search-api/generated-src";
import { ShadowTestApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

interface UseShadowTestResultParams {
  stage: Stage;
  transactionId: string | undefined;
}

export default function useShadowTestResult({
  stage,
  transactionId,
}: UseShadowTestResultParams) {
  const shadowTestApi = ShadowTestApiFactory();

  const { data, isLoading, isFetching, error, refetch } =
    useQuery<ShadowTestResultResponse | null>(
      ["shadowTestResult", stage, transactionId],
      async () => {
        try {
          const { data }: AxiosResponse<ShadowTestResultResponse> =
            await shadowTestApi.getShadowTestResult(stage, transactionId!);
          return data;
        } catch (err) {
          if (
            axios.isAxiosError(err) &&
            err.response &&
            err.response.status < 500
          ) {
            return null;
          }
          throw err;
        }
      },
      {
        enabled: !!transactionId && !!stage,
        retry: false,
        refetchOnWindowFocus: false,
      }
    );

  return {
    result: data,
    isLoading,
    isFetching,
    error: error as Error | null,
    refetch,
  };
}
